import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Service/defend/OffensiveMDR/OffensiveMDR.tsx");
